module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Mailbox-1992c11d3c967d5ed59fa7ecb3ea757d6b7e4e67a46c55a9ef84048d9946237a.svg";